import Helper from '@ember/component/helper';
import { getOwner } from '@ember/application';

/**
 * Returns true if `name` resolves to a registered component, false otherwise.
 *
 * Guards dynamic `{{component name}}` invocations where `name` comes from server
 * data (e.g. Application#dashboard_view) and may be stale, renamed or invalid.
 * An unresolvable name makes Glimmer's resolveComponent return null and then
 * throw "Cannot destructure property 'manager' from null or undefined value"
 * synchronously at render, crashing the whole route.
 * (Sentry EMBER-SCUOLE-SEGRETERIA-Z4)
 *
 * Uso: {{#if (component-exists this.dynamicName}} {{component this.dynamicName}} {{/if}}
 */
class ComponentExistsHelper extends Helper {
  compute([name]) {
    if (!name) {
      return false;
    }
    const owner = getOwner(this);
    return Boolean(owner && owner.hasRegistration(`component:${name}`));
  }
}

export { ComponentExistsHelper as default };
//# sourceMappingURL=component-exists.js.map
